import { ScoreUtil } from 'common/utils/scoreUtil';
import format from 'date-fns/format';

/**
 * @desciprtion 선택된 탭 조건에 의해 리스트 필터
 * @param {*} selectedTab
 * @param {*} sportsTypeKeyArr
 * @param {*} sportsView
 * @returns
 */
function getFilterList(sportsTypeKeyArr, sportsView) {
  let filterList = {
    soccer: [],
    baseball: [],
    basketball: [],
    volleyball: [],
    hockey: [],
    football: []
  };

  // ALL 일때 종료경기 빠짐
  sportsTypeKeyArr.forEach((key) => {
    filterList[key] = [
      ...sportsView[key].filter((item) => {
        if (
          item.sportsType === 'SOCCER' ||
          item.sportsType === 'BASKETBALL' ||
          item.sportsType === 'TENNIS'
        ) {
          if (
            item.gameStatus === 'IN_PROGRESS' ||
            item.gameStatus === 'BREAK_TIME' ||
            item.gameStatus === 'PAUSE'
          ) {
            if (item.betbleUri !== null) {
              return item;
            }
          }
        }
      })
    ];
  });

  return filterList;
}

function getReadyList(sportsTypeKeyArr, sportsView) {
  let filterList = {
    soccer: [],
    baseball: [],
    basketball: [],
    volleyball: [],
    hockey: [],
    football: []
  };

  // ALL 일때 종료경기 빠짐
  sportsTypeKeyArr.forEach((key) => {
    filterList[key] = [
      ...sportsView[key].filter((item) => {
        // if (item.sportsType !== 'TENNIS' && item.gameStatus === 'READY' && item.betbleUri !== null) {
        if (item.gameStatus === 'READY' && item.betbleUri !== null) {
          return item;
        }
      })
    ];
  });

  return filterList;
}

/**
 * @description Object를 list로 변경
 * @param {*} deleteSelectedGames
 * @returns
 */
function getConcatList(deleteSelectedGames) {
  let result = [];

  Object.keys(deleteSelectedGames).forEach((key) => {
    result = [...result, ...deleteSelectedGames[key]];
  });

  return ScoreUtil.sortSportsList(result);
}

export { getFilterList, getConcatList, getReadyList };
